import { render, staticRenderFns } from "./BatteryInfo.vue?vue&type=template&id=56cb7b9a"
import script from "./BatteryInfo.vue?vue&type=script&lang=js"
export * from "./BatteryInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports